import styled from 'styled-components'

export const Label = styled.label`
	color: ${({ theme }) => theme.color.input.textFaded};
	display: flex;
	flex-direction: column;
	font-size: 16px;
	margin-bottom: 0;
`
